import { faArrowToBottom } from '@fortawesome/pro-regular-svg-icons';
import React, { Component, PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';
import { fontAwesome, Icon } from '../Icon';
import './GridExport.scss';
import { IDataGridExportProps } from './types';

fontAwesome.library.add(faArrowToBottom);

export class GridExport extends Component<PropsWithChildren<IDataGridExportProps>, {}> {
  public render() {
    return (
      <div className={'hlc-datagrid-export-controls'}>
        <ThemeProvider theme={{ iconPadding: '2px 3.5px' }}>
          <Icon
            qa-id={this.props['qa-id']}
            title={this.props.dataCount > 0 ? 'Export' : 'No Data Available'}
            icon={['far', 'arrow-to-bottom']}
            size={'lg'}
            disabled={this.props.dataCount === 0}
            onClick={this.props.handleDataExport}
          />
        </ThemeProvider>
      </div>
    );
  }
}
